module.exports = __webpack_public_path__ + "03457099447c779c5afaea978d75a9ac.fbx";